import React from "react";
import { UserMinus, X } from "lucide-react";

interface ConfirmRemoveModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  email: string;
  organizationName: string;
}

const ConfirmRemoveModal: React.FC<ConfirmRemoveModalProps> = ({
  open,
  onClose,
  onConfirm,
  email,
  organizationName,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-background-paper dark:bg-background-paperDark p-6 rounded-lg shadow-lg w-full max-w-md">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <UserMinus className="w-6 h-6 text-red-500" />
            <h2 className="text-xl font-bold text-text-primary dark:text-text-primaryDark">
              Remove User
            </h2>
          </div>
          <button
            onClick={onClose}
            aria-label="Close"
            className="text-text-secondary dark:text-text-secondaryDark hover:text-text-primary dark:hover:text-text-primaryDark transition"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="mb-6">
          <p className="text-sm text-text-secondary dark:text-text-secondaryDark">
            Are you sure you want to remove{" "}
            <strong className="text-text-primary dark:text-text-primaryDark">
              {email}
            </strong>{" "}
            from the organization{" "}
            <strong className="text-text-primary dark:text-text-primaryDark">
              {organizationName}
            </strong>
            ?
          </p>
          <p className="text-xs text-text-secondary dark:text-text-secondaryDark mt-2">
            Removing this user will revoke all access to organizational
            resources. This action cannot be undone.
          </p>
        </div>

        <div className="bg-background-panel dark:bg-background-panelDark p-4 rounded-md mb-6">
          <p className="text-sm text-text-primary dark:text-text-primaryDark">
            <strong>Organization:</strong> {organizationName}
          </p>
        </div>

        <div className="flex justify-end gap-4">
          <button
            onClick={onClose}
            className="py-2 px-6 rounded-md text-sm font-medium border border-divider dark:border-divider-dark text-text-secondary dark:text-text-secondaryDark hover:bg-background-panel dark:hover:bg-background-panelDark transition"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="py-2 px-6 rounded-md text-sm font-medium bg-red-500 text-white hover:bg-red-600 transition"
          >
            Remove User
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmRemoveModal;
